var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setting-wrap"},[_c('div',{staticClass:"setting-label",style:({ width: (_vm.labelWidth + "px") })},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }